import classNames from "classnames";
import SkeletonElement from "./SkeletonElement";
import type { MetricCardSize } from "@/components/MetricCard/MetricCard.types";
import { METRIC_CARD_MIN_HEIGHT_CLASS } from "@/components/MetricGrid/metricGridLayout";

type MetricCardSkeletonProps = {
  className?: string;
  size?: MetricCardSize;
};

export default function MetricCardSkeleton({ className = "", size = "default" }: MetricCardSkeletonProps) {
  return (
    <div
      className={classNames(
        "p-4 flex flex-col h-full rounded-lg border border-sys-brand-outline-variant min-w-0 w-full",
        size === "default" && METRIC_CARD_MIN_HEIGHT_CLASS,
        className
      )}
      data-testid="metric-card-skeleton"
    >
      <SkeletonElement height="h-10" width="w-10" rounded="rounded-md" className="mb-4" />
      <SkeletonElement height="h-6" width="w-24" className="mb-2" />
      <SkeletonElement height="h-4" width="w-32" />
    </div>
  );
}
